import { defineComponent as _defineComponent } from 'vue'
import { QuotePriceResponse, TradeFundingDetails } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import OldTradeFundForm from '../../forms/tradeFundForm/OldTradeFundForm.vue';
import { useTradeState } from '../../..';
import { computed, watch, onBeforeMount } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';

/**
 * FIXME - This component serves the purpose to render the old flow of forward trades (US's PT-1828 and PT-1829)
 * This will exist until we remove the VARIATION_MARGIN_AND_LIMITS_FEATURE feature flag
 * After that, and since this component is only used here, we should remove it
 * */


export default /*#__PURE__*/_defineComponent({
  __name: 'OldTradePriceMarginInfo',
  props: {
    tradePriceResponse: null,
    tradeFundingDetails: null,
    hideFundingForm: { type: Boolean, default: false }
  },
  emits: ["update:sufficientCollateral", "update:tradeFundingDetails"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:sufficientCollateral', value: boolean): void;
  (e: 'update:tradeFundingDetails', value: Partial<TradeFundingDetails>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tradePriceResponse: QuotePriceResponse, tradeFundingDetails?: Partial<TradeFundingDetails>, hideFundingForm: boolean | false };

const tradeState = useTradeState();

const onBehalfOfClient = useOnBehalfOf();





const collaterals = computed(() => {
  const clientId = onBehalfOfClient.value
    ? onBehalfOfClient.value.id
    : tradeState.store.useAuthStore().loggedInIdentity?.client?.id;

  if (clientId) {
    return tradeState.store.useWalletsStore().getCollaterals(clientId);
  }
  return null;
});

const shouldHideIMFundingForm = computed(() => props.hideFundingForm !== false);

const areCollateralsLoading = computed(() => {
  return tradeState.store.useWalletsStore().areCollateralsLoading(onBehalfOfClient.value?.id);
});

const sufficientCollateral = computed(() => {
  if (!collaterals.value || areCollateralsLoading.value) {
    return false;
  }

  return (
    props.tradePriceResponse.homeCurrencyInitialMarginAmount <= 0 ||
    collaterals.value.marginCollateralAvailable >= props.tradePriceResponse.homeCurrencyInitialMarginAmount
  );
});

onBeforeMount(() => {
  tradeState.store.useWalletsStore().loadCollaterals({ force: false, clientId: onBehalfOfClient.value?.id });
});

/**
 * Reset tradeFundingDetails whenever Initial Margin is not required
 */
watch(
  () => props.tradePriceResponse.homeCurrencyInitialMarginAmount > 0,
  (imRequired) => {
    if (!imRequired) {
      emit('update:tradeFundingDetails', {});
    }
  },
  { immediate: true }
);

watch(
  () => props.tradePriceResponse,
  () => {
    tradeState.store.useWalletsStore().loadCollaterals({ force: true, clientId: onBehalfOfClient.value?.id });
  },
  { immediate: true }
);

watch(
  sufficientCollateral,
  () => {
    emit('update:sufficientCollateral', sufficientCollateral.value);
  },
  { immediate: true }
);

return { __sfc: true,tradeState, onBehalfOfClient, emit, props, collaterals, shouldHideIMFundingForm, areCollateralsLoading, sufficientCollateral, formatCurrencyValue, OldTradeFundForm }
}

})